<script setup>
import { onMounted, ref } from 'vue'
import { api } from '../services/api'

const data = ref(null)
const error = ref('')

onMounted(async () => {
  try { data.value = await api('/progress') }
  catch (err) { error.value = err.message }
})
</script>

<template>
  <header><p class="eyebrow">Phân tích học tập</p><h1 class="page-title">Tiến bộ của em</h1><p class="page-subtitle">Mỗi con số là một dấu mốc. Nhìn lại để biết mình đã làm tốt điều gì và nên tập trung vào đâu.</p></header>
  <div v-if="error" class="error-banner" style="margin-top:20px">{{ error }}</div>
  <div v-if="!data && !error" class="loading-block"><div><div class="loader"></div><p>Đang tổng hợp kết quả…</p></div></div>
  <template v-else-if="data">
    <section class="stats-grid">
      <div class="card stat-card"><div class="stat-icon">✓</div><div><strong>{{ data.stats.completed_lessons }}</strong><small>Bài hoàn thành</small></div></div>
      <div class="card stat-card"><div class="stat-icon">◷</div><div><strong>{{ data.stats.study_minutes }}</strong><small>Phút học</small></div></div>
      <div class="card stat-card"><div class="stat-icon">☆</div><div><strong>{{ data.stats.average_score }}%</strong><small>Điểm trung bình</small></div></div>
      <div class="card stat-card"><div class="stat-icon">♨</div><div><strong>{{ data.stats.streak_days }}</strong><small>Ngày liên tiếp</small></div></div>
    </section>

    <div class="report-grid">
      <section class="card chart-card">
        <h2>Tiến độ theo môn học</h2>
        <div class="bar-chart"><div v-for="subject in data.subjects" :key="subject.id" class="chart-bar" :class="subject.color" :style="{ '--value': Math.max(subject.progress.percent, 3) }"><span>{{ subject.progress.percent }}%</span></div></div>
        <div class="chart-labels"><span v-for="subject in data.subjects" :key="subject.id">{{ subject.title }}</span></div>
      </section>
      <section class="card chart-card">
        <h2>Chủ đề cần củng cố</h2>
        <div v-if="data.weak_topics.length" class="mastery-list"><div v-for="topic in data.weak_topics" :key="topic.chapter_id" class="mastery-item"><div><b>{{ topic.title }}</b><span>{{ topic.accuracy }}%</span></div><div class="progress-track"><span :style="{ width: `${topic.accuracy}%`, background: topic.accuracy < 60 ? '#e8894f' : '#dfb43f' }"></span></div></div></div>
        <div v-else class="empty-state"><strong>Chưa có điểm yếu nổi bật</strong>Hoàn thành thêm bài luyện tập để hệ thống phân tích.</div>
      </section>
    </div>

    <div class="section-heading"><div><h2>Lịch sử bài làm</h2><p>Kết quả luyện tập và kiểm tra gần đây</p></div></div>
    <section class="card" style="overflow:auto">
      <table class="attempt-table"><thead><tr><th>Bài làm</th><th>Môn</th><th>Kết quả</th><th>Ngày</th><th>Trạng thái</th></tr></thead><tbody><tr v-for="attempt in data.attempts" :key="attempt.id"><td>{{ attempt.title }}</td><td>{{ attempt.subject }}</td><td><span class="score-pill" :class="{ low: attempt.percent < 60 }">{{ attempt.percent }}%</span></td><td>{{ attempt.date }}</td><td>{{ attempt.status === 'ai_reviewed' ? 'Gợi ý theo tiêu chí' : 'Đã chấm' }}</td></tr></tbody></table>
      <div v-if="!data.attempts.length" class="empty-state"><strong>Chưa có bài làm</strong>Hãy chọn một bài luyện tập để bắt đầu.</div>
    </section>
  </template>
</template>
